'use client'

import type { StorageInstance } from 'storage/domain/Storage'
import { getStorageInstance } from 'storage/services/getStorageInstance'
import type { MasterData } from 'types/masterData'

import { SESSION_CACHE_KEY, SESSION_DIFF_TIMESTAMP } from '../constants'

export const sessionCache = (masterData: MasterData): StorageInstance =>
	getStorageInstance({
		cacheKey: SESSION_CACHE_KEY,
		maxDiffTimestamp: SESSION_DIFF_TIMESTAMP,
		masterData,
	})
